import axios from "axios";
import config from "../../config";
import { UploadFileRequest } from "./types";

const apiUrl = config.api;

export const uploadFile = async (payload: UploadFileRequest) => {
  const response = await axios.post(`${apiUrl}/import`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data;
};

export default uploadFile;
